<template>
  <SubContent @back="goback">
    <template v-slot:nav_left>
      {{tutorial.title}}
    </template>
    <div class="scroll_wrap tutorial-wrapper">
      <vue-scroll v-show="!loading" >
        <div class="tutorial_info">
          <div class="info">
            <div><span>{{$t('type')}}/{{tutorial.categoryZh}}</span><span v-show="tutorial.skillLevelZh">{{$t('team1')}}/{{tutorial.skillLevelZh}}</span></div>
            <div>{{$t('lastUpdateTime')}}/{{tutorial.updatedAt | time(true)}}</div>
            <div v-if="tutorial.owner || tutorial.haveVideo ">
              视频：
              <span class="video-btn" @click="mediaMore">查看 </span>
              <span v-if="tutorial.owner" style="margin-right: 0"> / </span>
              <span v-if="tutorial.owner" class="video-btn" @click="addMedia">本地上传视频</span>
              <span v-if="tutorial.owner" style="margin-right: 0"> / </span>
              <span v-if="tutorial.owner" class="video-btn" @click="associateMore">视频库中选择</span>
            </div>
            <div v-if="sessionLinks.length > 0 || tutorial.owner">
              外部链接：
              <div v-for="item in sessionLinks" :key="item.uuid" class="link-tab-warp">
                <a :href="$yioksConfig.transferBaseOnly(item.linkAddress)" class="linktab" target="_blank">{{ item.linkTitle }}</a>
                <i v-if="tutorial.owner" class="el-icon-edit link-icon" @click="editLink(item)"></i>
                <i v-if="tutorial.owner" class="el-icon-delete link-icon" @click="linkUuid = item.uuid;deleteLinkTip = true"></i>
              </div>
              <span
                v-if="tutorial.owner"
                class="video-btn"
                style="margin-left:10px;display:inline-block;width:70px"
                @click="addLinkTip = true">添加链接</span>
            </div>
            <div class="icon_wrap" v-if="isCanEditData">
              <img
                v-if="!start"
                src="@/assets/images/common/star.png"
                :title="$t('collect')"
                @click="startTutorial">
              <img
                v-if="start"
                src="@/assets/images/common/star_copy.png"
                :title="$t('removeCollection')"
                @click="startTutorial">
              <img
                v-if="!thumb"
                src="@/assets/images/common/thumb.png"
                :title="$t('salute')"
                style="margin-right:0"
                @click="thumbTutorial">
              <img
                v-if="thumb"
                src="@/assets/images/common/thumb_copy.png"
                :title="$t('salute')"
                style="margin-right:0"
                @click="thumbTutorial">
                <span style="margin-right:.25rem">({{recommendNumber}})</span>
              <img
                v-if="copyShow.includes(userRole)"
                src="@/assets/images/common/copy_btn.png"
                :title="$t('copyPlan')"
                @click="copyTutorial">
              <a
                v-show="false"
                ref="download_btn"
                :href="$yioksConfig.transferBaseOnly(pdf_url)"
                :download="pdf_name"></a>
              <img src="@/assets/images/common/down.png" :title="$t('downloadPlan')" @click="downTutorial">
              <div v-if="tutorial.owner" class="mine">
                <img src="@/assets/images/common/edit.png" :title="$t('editPlan')" @click="editTutorial">
                <img src="@/assets/images/common/remove.png" :title="$t('removePlan')" @click="showTip = true">
                {{$t('sharedPermission')}}
                <select v-model="sharingStatus" class="select" @change="updateSharingStatus">
                  <option value="Club">内部可看</option>
                  <option value="Private">仅个人可看</option>
                </select>
              </div>
            </div>
          </div>
          <div class="user">
            <img :src="tutorial.authorHeadImgUrl ? tutorial.authorHeadImgUrl : person" alt="" @error="tutorial.authorHeadImgUrl = person">
            <div>
              <p class="name">{{tutorial.authorName}}</p>
              <p>{{$t('professionalFootballCoach')}}</p>
            </div>
          </div>
        </div>
        <div v-if="tutorial.overallDescription" class="description">
          <p>{{$t('generalDescription')}}：</p>
          <div v-html="tutorial.overallDescription"></div>
        </div>
        <div class="tutorial_wrap">
          <div class="left">
            <div class="title">
              <div><span class="name">{{detail.drillTitle || '--'}}</span></div>
              <div class="time">{{detail.timeSpent || "--" }}分钟</div>
            </div>
            <div class="flashWrap">
              <div class="down">
                <!--<div v-if="flashFlag" class="flash">-->
                  <!--<div v-for="(item, index) in linkList" :key="index">-->
                    <!--<object-->
                      <!--v-if="idx === index"-->
                      <!--id=""-->
                      <!--:key="item.id"-->
                      <!--type="application/x-shockwave-flash"-->
                      <!--name="sspviewer"-->
                      <!--align="middle"-->
                      <!--:data="`${HOSTURL}/uploads/flash-tool/yioks-football-view.swf?revision=1463`"-->
                      <!--width="577"-->
                      <!--height="322">-->
                      <!--<param name="quality" value="high">-->
                      <!--<param name="bgcolor" value="#000000">-->
                      <!--<param name="play" value="false">-->
                      <!--<param name="loop" value="false">-->
                      <!--<param name="wmode" value="transparent">-->
                      <!--<param name="scale" value="showall">-->
                      <!--<param name="menu" value="true">-->
                      <!--<param name="devicefont" value="false">-->
                      <!--<param name="salign" value="">-->
                      <!--<param name="allowscriptaccess" value="sameDomain">-->
                      <!--<param name="allowfullscreen" value="true">-->
                      <!--<param name="flashvars" :value="`xmlRequestFile=/api/editor/myXmlView?sessionUuid=${sessionUuid}&screenSortOrder=${idx}`">-->
                    <!--</object>-->
                  <!--</div>-->
                <!--</div>-->
                <img class="placeholder_img" :src="detail.coverImgUrl" @error="detail.coverImgUrl = placeHolderImg">
                <template v-if="isShowCom">
                  <yioks-sspviewer  :screenId="idx" :requestXmlUrl="`/api/editor/myXmlView?sessionUuid=${sessionUuid}`" />
                </template>
              </div>
              <!--<div v-if="!flashFlag" class="flashTipsImg">-->
                <!--<a href="https://get2.adobe.com/cn/flashplayer/" style="">-->
                  <!--<img :src="FlashTips" alt="">-->
                <!--</a>-->
              <!--</div>-->
              <div class="flashLines">
                <div v-if="lineList.length" class="lines_key" :style='"background: url(" + Grass + ") top left repeat;"'>
                  <div class="key block">
                    <div v-for="(item, index) in lineList" :key="index" class="col">
                      <div class="line_container block" :style='"border-color:"+item._lineColor+""'>
                        <img
                          :src='"@/assets/images/arrows/arrow_left_"+ item._arrowThickness_left +".png"'
                          width="15"
                          height="20"
                          alt="Arrow Large"
                          style="position:absolute; top:0px; left:0px;"/>
                        <img
                          :src='"@/assets/images/lines/line_"+item._lineStyle+"_"+item._lineType+"_"+item._lineThickness+".png"'
                          width="50"
                          height="20"
                          alt="Line Straight 2px"
                          style="position:absolute; top:-0px; left:15px;"/>
                        <img
                          :src='"@/assets/images/arrows/arrow_right_"+item._arrowThickness_right +".png"'
                          width="15"
                          height="20"
                          alt="Arrow Medium Right"
                          style="position:absolute; top:-0px; left:65px;"/>
                      </div>
                      <p class="drill">{{item.name_zh}}</p>
                    </div>
                    <div class="clear"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="linkDescription">
<!--              <div class="link_title">-->
<!--                <div class="link_title_item">{{$t('linkDescription')}}</div>-->
<!--                <div class="link_title_item">五环能力</div>-->
<!--              </div>-->
              <div class="nav-wrapper">
                <div class="nav-item" :class="activeIdx === 'intro' ? 'active': ''" @click="linkNavClick('intro')">{{$t('linkDescription')}}</div>
                <div class="nav-item" :class="activeIdx === 'ability' ? 'active': ''" @click="linkNavClick('ability')" v-if="detail._skillsTechnical !=='-1'">五环能力</div>
              </div>
              <template v-if="activeIdx === 'intro'">
                <div class="link_content" v-html="detail.drillComment"></div>
              </template>
              <template v-else>
                <div class="link_content">
                  <div class="yioks-table">
                    <div class="row">
                      <div class="td title">
                        <img src="@/assets/images/sessionPlan/player_records_tactical.png"/> <span>  技术能力<span v-if="detail._skillsTechnical">({{detail._skillsTechnical}}%)</span></span>
                      </div>
                      <div class="td content">
                        <p>{{detail._skillsTechnicalComment}}</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="td title">
                        <img src="@/assets/images/sessionPlan/player_records_technical.png"/><span> 战术能力<span v-if="detail._skillsTactical">({{detail._skillsTactical}}%)</span></span>
                      </div>
                      <div class="td content">
                        <p>{{detail._skillsTacticalComment}}</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="td title">
                        <img src="@/assets/images/sessionPlan/player_records_physical.png"/><span> 体能<span v-if="detail._skillsPhysical">({{detail._skillsPhysical}}%)</span></span>
                      </div>
                      <div class="td content">
                        <p>{{detail._skillsPhysicalComment}}</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="td title">
                        <img src="@/assets/images/sessionPlan/player_records_psychological.png"/><span> 心智能力<span v-if="detail._skillsPsychological">({{detail._skillsPsychological}}%)</span></span>
                      </div>
                      <div class="td content">
                        <p>{{detail._skillsPsychologicalComment}}</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="td title">
                        <img src="@/assets/images/sessionPlan/player_records_social.png"/><span> 社交能力<span v-if="detail._skillsSocial">({{detail._skillsSocial}}%)</span></span>
                      </div>
                      <div class="td content">
                        <p>{{detail._skillsSocialComment}}</p>
                      </div>
                    </div>

                  </div>
                </div>
              </template>

            </div>
          </div>
          <div class="right">
            <p>{{$t('allLinks')}}</p>
            <p
              v-for="(item, index) in linkList"
              :key="index"
              class="link"
              :class="idx === index ?'active':'hover' "
              @click="switchTab(item.drillTitle, index)"
              >{{item.drillTitle || '--'}}</p>
          </div>
        </div>
      </vue-scroll>
      <yioks-loading v-if="loading"></yioks-loading>
      <yioks-tip :showTip="showTip" :tipMsg="$t('deleteTeachingPlanTips')" @callback='delTutorial' />
      <template v-if="showDialog">
        <associateMore
          :objectUuid="tutorial.uuid"
          :type="link.type"
          :obj="propObj"
          :title="link.title"
          :organUuid="orgInfo.organUuid"
          :youthUuid="orgInfo.youthUuid"
          :showDialog.sync="showDialog"
          mediaType="plan"
          @hideDialog="hideDialog"></associateMore>
      </template>
      <!-- 系统管理员上传教案视频 -->
      <template v-if="showMediaUpload">
        <uploadMedia
          :showTip.sync="showMediaUpload"
          :orgInfo="orgInfo"
          :uuid="tutorial.uuid"
          type="plan"
          :isSquadShow="true"
          :videoType="'tutorial'"
          :sequadSelectList="sequadSelectList"
          @hideUploadDialog ="hideUploadDialog"></uploadMedia>
      </template>
      <el-dialog
        :visible.sync="addLinkTip"
        width="500px"
        title="添加链接"
        class="yioks_alert"
        :close-on-click-modal="false"
        top="12vh">
        <div>
          <el-form ref="linkForm" label-width="80px" :model="linkForm">
            <el-form-item label="链接名称" prop="linkTitle" :rules="{ required: true, message:'请输入链接名称', trigger: 'blur'}">
              <el-input v-model="linkForm.linkTitle" style="width:380px" maxlength="20" />
            </el-form-item>
            <el-form-item label="链接地址" prop="linkAddress" :rules="{ required: true, message:'请输入链接地址', trigger: 'blur'}">
              <el-input v-model="linkForm.linkAddress" style="width:380px"  maxlength="200" />
            </el-form-item>
          </el-form>
          <div style="text-align:center;padding-top:10px">
            <el-button
              type="primary"
              style="margin-right:20px"
              :loading="btnLoading"
              @click="operateLink">确定</el-button>
            <el-button type="danger" @click="addLinkTip = false">取消</el-button>
          </div>
        </div>
      </el-dialog>
      <yioks-tip :showTip="deleteLinkTip" tipMsg="确定要删除该链接吗？" @callback='deleteLink' />
    </div>
  </SubContent>
</template>

<script>

import person from '@/assets/images/common/person.jpg'
import Grass from '@/assets/images/common/grass.gif'
import FlashTips from '@/assets/images/common/flash_tips.png'
import placeHolderImg from '@/assets/images/common/plan_default_big.jpg'
import { flashCheck } from '@/utils/yioks_filter'
import tutorial from '@/api/tutorial'
import storage from '@/utils/storage'
import squad from '@/api/squad'
import mixinAppConfig from "@/mixin/mixinAppConfig";
export default {
  components: {
    'SubContent': () => import('@/components/layout/SubContent'),
    'associateMore': () => import('@/components/associatedDialog/associatedMore'),
    'uploadMedia': () => import('@/views/media/uploadMedia'),
    "yioks-sspviewer": () => import("@/components/sspViewer/sppCanvas")
  },
  mixins: [mixinAppConfig],
  data () {
    return {
      nowIdx: 'intro',
      FlashTips,
      Grass,
      placeHolderImg,
      person,
      userRole: storage.get('userInfo').userRole,
      copyShow: [ 'coach'],
      start: false,
      thumb: false,
      isShowCom: true,
      pdf_url: '',
      pdf_name: '',
      idx: 0,
      lineList: [], // 教案中线条
      flashFlag: false, // 是否允许flash
      sessionUuid: this.$route.query.uuid, // 教案的uuid
      tutorial: {}, // 教案详情
      linkList: [], // 所有环节
      detail: [],
      loading: true,
      HOSTURL: process.env.VUE_APP_URL,
      sharingStatus: 'Club',
      recommendNumber: 0,
      navIdx: this.$route.query.idx ? this.$route.query.idx : 0,
      showTip: false,
      showMediaUpload: false,
      orgInfo: {
        organUuid: '',
        organShortName: '',
        youthUuid: '',
        youthShortName: ''
      },
      showDialog: false,
      link: {
        title: '',
        type: ''
      },
      propObj: {},
      videoSrc: '',
      poster: '',
      showVideo: false,
      addLinkTip: false,
      linkForm: {
        linkAddress: '',
        linkTitle: '',
        sessionUuid: this.$route.query.uuid
      },
      sessionLinks: [],
      linkUuid: '',
      btnLoading: false,
      deleteLinkTip: false,
      sequadSelectList: [],
    }
  },
  computed: {
    activeIdx: {
      get() {
        return this.nowIdx || 'intro'
      },
      set(val) {
        this.nowIdx = val;
      }
    }
  },

  watch: {
    idx (val) {
      this.detail = this.linkList[val]
    },
    addLinkTip (val) {
      if (!val) {
        this.$refs.linkForm.resetFields()
        this.linkForm = {
          linkAddress: '',
          linkTitle: '',
          sessionUuid: this.sessionUuid
        }
        this.linkUuid = ''
      }
    },
    deleteLinkTip (val) {
      if (!val) this.linkUuid = ''
    }
  },
  created () {
    this.flashFlag = flashCheck()
    this.getDetail()
    this.loadSearchSelectList()
  },
  methods: {
    getDetail () {
      tutorial.getTutorialDetail({ sessionUuid: this.sessionUuid }).then(res => {
        this.loading = false
        if (res.code === 'TeachingUuidInexistence') {
          this.$message.error('教案不存在')
          this.$router.push('/')
        } else {
          this.getSessionLinks()
          this.tutorial = res
          this.linkList = res.planTacticalDrills
          if (this.linkList.length > 0) {
            this.detail = res.planTacticalDrills[0]
          }
          this.lineList = res.planTacticalLineListVos
          this.start = res.favorite
          this.thumb = res.recommend
          this.recommendNumber = res.teachingExpand.recommendNumber
          this.sharingStatus = res.teachingExpand.sharingStatus
          res.teachingExpand && res.teachingExpand.organUuid && this.$set(this.orgInfo, 'organUuid', res.teachingExpand.organUuid)
          res.teachingExpand && res.teachingExpand.organShortName && this.$set(this.orgInfo, 'organShortName', res.teachingExpand.organShortName)
          res.teachingExpand && res.teachingExpand.youthUuid && this.$set(this.orgInfo, 'youthUuid', res.teachingExpand.youthUuid)
          res.teachingExpand && res.teachingExpand.youthShortName && this.$set(this.orgInfo, 'youthShortName', res.teachingExpand.youthShortName)
        }
      }).catch(err => {
        this.loading = false
        console.error(err)
      })
    },
    startTutorial () {
      this.start = !this.start
      let requestName = tutorial.favoriteAdd
      if (!this.start) requestName = tutorial.favoriteRemove
      requestName({ sessionUuid: this.tutorial.uuid }).then(res => {
        if (this.start) {
          this.$message.success('收藏成功')
        } else {
          this.$message.success('取消成功')
        }
      })
    },
    thumbTutorial () {
      if (this.thumb) return
      tutorial.recommendAdd({ authorUserUuid: this.tutorial.authorUserUuid, sessionUuid: this.tutorial.uuid }).then(res => {
        this.$message.success('点赞成功')
        this.thumb = true
        this.recommendNumber += 1
      })
    },
    copyTutorial () {
      window.location.href = `/static/session_editor/sspeditor.html?copySessionUuid=${this.sessionUuid}&sessionKind=train`
    },
    goback () {
      if (this.tutorial.owner) {
        const { idx, typeIdx, squadIdx, lgIdx,title,page,id ,child_index} = this.$route.query
        this.$router.push({
          path: 'list',
          query: {
            idx,
            typeIdx,
            squadIdx,
            lgIdx,
            page,
            title,
            child_index,
            id
          }
        })
      } else {
        this.$router.go(-1)
      }
    },
    updateSharingStatus () {
      tutorial.updateSharingStatus({ sessionUuid: this.tutorial.uuid, sharingStatus: this.sharingStatus }).then(res => {
        this.$message.success('修改成功')
      })
    },
    downTutorial () {
      tutorial.downloadTeachingPdf({ sessionUuid: this.tutorial.uuid }).then(res => {
        if (res.fileName && res.filePath) {
          this.pdf_url = res.filePath
          this.pdf_name = res.fileName
          this.$nextTick(() => {
            this.$refs.download_btn.click()
          })
        }
      })
    },
    editTutorial () {
      // this.$router.push({
      //   path: 'edit',
      //   query: this.$route.query
      // })
      let goto = 'tutorial/detail' + window.location.search;
      window.location.href = `/static/session_editor/sspeditorEdit.html?sessionUuid=${this.tutorial.uuid}&goto=${goto}`
    },
    delTutorial (isSure) {
      if (isSure) {
        tutorial.teachingRemove({ sessionUuid: this.tutorial.uuid }).then(res => {
          // this.goback()
          this.$message.success('删除成功')
          this.$router.push({
            path: 'list',
            query: {
              idx: 5
            }
          })
        })
      } else {
        this.showTip = false
      }
    },
    addMedia () {
      this.showMediaUpload = true
    },
    associateMore () {
      this.$set(this.link, 'type', 'media')
      this.$set(this.link, 'title', '从视频库中选择')
      this.showDialog = true
    },
    hideUploadDialog (val) {
      this.showMediaUpload = val
    },
    hideDialog (val) {
      this.showDialog = val
    },
    mediaMore () {
      this.$router.push({
        path: 'moreMedia',
        query: {
          uuid: this.tutorial.uuid,
          title: '已关联视频'
        }
      })
    },
    getSessionLinks () {
      tutorial.sessionLinks(this.sessionUuid).then(res => {
        if (!res.code) this.sessionLinks = res
      })
    },
    editLink (item) {
      this.linkUuid = item.uuid
      this.linkForm.linkAddress = item.linkAddress
      this.linkForm.linkTitle = item.linkTitle
      this.addLinkTip = true
    },
    operateLink () {
      this.$refs.linkForm.validate(vali => {
        if (vali) {
          this.btnLoading = true
          let requestName = tutorial.addLinks
          const data = { ...this.linkForm }
          if (this.linkUuid) {
            requestName = tutorial.editLinks
            data.uuid = this.linkUuid
          }
          requestName({ links: data }).then(res => {
            this.btnLoading = false
            this.addLinkTip = false
            this.$message.success('添加成功')
            this.getSessionLinks()
          }).catch(() => {
            this.btnLoading = false
          })
        }
      })
    },
    switchTab(name, idx) {
      // this.itemDetail = this.list[idx];
      this.isShowCom = false;
      // this.itemIdx = idx;
      this.activeIdx='intro'
      this.$nextTick(() =>{
        this.detail = this.linkList[idx];
        this.idx = idx;
        this.isShowCom = true;
      })
    },
    deleteLink (sure) {
      if (sure) {
        tutorial.removeLinks(this.linkUuid).then(res => {
          if (!res.code) {
            this.getSessionLinks()
          }
        })
      }
      this.deleteLinkTip = false
    },
    linkNavClick(activeName) {
      const path = this.$route.path;
      const querys = this.$route.query;
      // this.$router.replace({
      //   path,
      //   query: {
      //     ...querys,
      //     activeIdx: activeName
      //   }
      // })
      this.activeIdx = activeName;
    },
    // 设置球队列表 下拉框搜索可选项；
    async loadSearchSelectList() {
      const _ = require('lodash');
      if(this.userRole === 'coach') {
        try {
          console.warn('获取新的查询列表')
          const res = await squad.getSquadListCoachAll();
          if(res.code) {
            this.$message.error(res.msg);
            return
          }
          // 生成单位可选列表
          const uni_selectYouthList = _.unionBy(res, 'youthUuid')
          this.sequadSelectList = uni_selectYouthList.map(item => {
            const { organShortName, youthShortName, youthUuid, organUuid } = item;
            return {
              label: `${ organShortName } - ${ youthShortName }`,
              value: JSON.stringify({ organShortName, youthShortName, youthUuid, organUuid })
            }
          })
        } catch(err) {
          console.error('err', err)
        }
      }
    },
  }
}
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable'

  html
    font-size 100px
  .scroll_wrap
    flex 1
    overflow hidden
    padding .2rem 0
    color #DDD
    .tutorial_info
      padding-top .1rem
      padding-bottom .25rem
      border-bottom 1px solid #FFF
      margin 0 .3rem
      display flex
      justify-content space-between
      .info
        div
          margin-bottom .2rem
        span
          margin-right .3rem
        .icon_wrap
          display flex
          align-items center
          .mine
            display flex
            align-items center
            margin-bottom 0
            .select
              margin-left .1rem
              height .4rem
              padding-left .1rem

          img
            cursor pointer
            margin-right .25rem
          span
            margin 0 0 0 .1rem
        .video-btn
          cursor pointer
          margin 0
          color $green_color
        .link-tab-warp
          // border 1px solid #FFF
          margin-bottom 0
          padding 5px
          display inline-block
          border-radius 5px
          .linktab
            color #FFF
            border-bottom 1px solid #FFF
            &:hover
              color $green_color
              border-color $green_color
          .link-icon
            color $green_color
            margin-left 10px
            cursor pointer
      .user
        display flex
        align-items center
        .name
          font-size .2rem
          margin-bottom .3rem
          min-width 1.15rem
        img
          width .9rem
          height .9rem
          border-radius .9rem
          margin-right .1rem
    .description
      padding .2rem 0
      margin 0 .3rem
      border-bottom 1px solid #FFF
      line-height .22rem
    .tutorial_wrap
      margin .15rem .3rem 0
      display flex
      .left
        flex 1
        padding-right .3rem
        .title
          display flex
          /*justify-content space-between*/
          align-items center
          .name
            font-size .18rem
            margin-right .3rem
        .flashWrap
          margin-top .1rem
          .down
            position relative
            min-height 3.43rem
            .flash
              position relative
              z-index 2
            .placeholder_img
              width 562px
              height 320px
              position absolute
              top 0
              left 0
              z-index 1
          .flashTipsImg
            margin .1rem 0
            width 2.26rem
            heigth .29rem
          .flashLines
            padding 10px 6px 0px 0px
            font-size 10px
            .lines_key
              margin-bottom 15px
              padding 10px 0 5px 0
              border 1px solid #386800
              height auto
              .col
                width 33%
                float left
                margin-bottom 5px
                display flex
                align-items center
                color #FFF
              .block
                display block
              .clear
                clear both
                display block
                overflow hidden
                visibility hidden
                width 0
                height 0
              .line_container
                float left
                width 80px
                height 0
                border-top 20px solid #FFF
                position relative
                margin-left 5px
              .line_container img
                display block
                background none
                float left
                margin-top -20px
              .drill
                position relative
                z-index 5
        .linkDescription
          .nav-wrapper
            padding .12rem 0
            border-bottom 1px solid #fff
            font-size .18rem
            display flex
            .nav-item
              cursor pointer
              margin-right .12rem
            .active
              color: $green_color
          .link_title
            padding-bottom .2rem
            border-bottom 1px solid #FFF
            font-size .18rem
            cursor pointer
            color $green_color
          .link_content
            padding-top .2rem
            padding-bottom .4rem
      .right
        border-left 1px solid #FFF
        padding .05rem 0 0 .2rem
        font-size .18rem
        min-width 1.8rem
        .link
          color #FFF
          padding .1rem .2rem
          margin-top .15rem
          border 2px solid transparent
          cursor pointer
          &.active
            background $green_color
          &.hover
            &:hover
              background url('~@/assets/images/common/hover_img.png') no-repeat right top
              box-shadow inset 0 0 12px #4cd964
              color #ddd
              border 2px solid #4cd964


  .yioks-table {
    border 1px solid #FFFFFF
    .row {
      display flex
      border-bottom 1px solid #FFFFFF
      &:last-child {
        border-bottom none
      }
      .td {
        height 50px
        display flex
        justify-content center
        align-items center
        border-right 1px solid #fff
        &:last-child {
          border-right none
        }
        p {

        }
      }
      .title {
        width 30%
        span {
          text-align center
          width 67%
        }
      }
      .content {
        width 70%
        p {
          padding 3px
        }
      }
    }
  }
</style>


<style lang="stylus">
  html
    font-size 100px
  /*.tutorial-wrapper {*/
    .viewer {
      .out-buttons3d-box {
        margin-top: 290px !important;
      }
    }
  //}
</style>
